// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"59":"7d988941","418":"7f1a95b8","751":"fea139f2","936":"d47f1970"}[chunkId] + ".chunk.css";
};